import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import { authRoutes } from '@/router/authRoutes'

const { repairsRoutes } = await import('repairsApp/repairsRoutes').catch(() => ({ repairsRoutes: [] }))
const { projectsRoutes } = await import('projectsApp/projectsRoutes').catch(() => ({ projectsRoutes: [] }))
const { controlZonesRoutes } = await import('controlsApp/controlZonesRoutes').catch(() => ({ controlZonesRoutes: [] }))
const { videoRoutes } = await import('videoApp/videoRoutes').catch(() => ({ videoRoutes: [] }))
const { usersRoutes } = await import('usersApp/usersRoutes').catch(() => ({ usersRoutes: [] }))

const guestPages = ['sign-in', 'sing-out', 'reset-password', 'verify-password']

const routes: RouteRecordRaw[] = [
  ...authRoutes,
  {
    path: '/',
    name: 'main',
    meta: {
      layout: 'Layout',
    },
    component: () => import('@/pages/index.vue'),
    redirect: () => '/user-profile',
    children: [
      ...repairsRoutes,
      ...projectsRoutes,
      ...controlZonesRoutes,
      ...videoRoutes,
      ...usersRoutes,
      {
        path: '/:catchAll(.*)',
        name: 'ritm-front',
        component: () => import('@/pages/ritm/index.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const isLogged = Boolean(
    localStorage.getItem('token') && localStorage.getItem('user') !== '' && localStorage.getItem('configs') !== '[]',
  )
  if (!isLogged && !guestPages.includes((to.name as string) || '')) {
    window.location.href = '/sign-in'
    return next()
  }
  if (isLogged && to.fullPath === '/sign-in') window.location.href = '/user-profile'
  if (!to.meta?.authority && !to.meta?.permission) return next()

  const goPage404 = () => next({ name: 'not-found' })
  return next()
})

export default router
